import { render, staticRenderFns } from "./PhosphorIcon.vue?vue&type=template&id=d9cbd586"
import script from "./PhosphorIcon.vue?vue&type=script&lang=js"
export * from "./PhosphorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports